export const fakePlatforms: Array<{code: string; title: string}> = [
  {code: 'autoscout24', title: 'AutoScout24'},
  {code: 'fastback_trade', title: 'Fastback Trade'},
  {code: 'fastback_inter_dealer', title: 'Fastback Inter Dealer'},
  {code: 'community', title: 'Community'},
];
